import React from 'react';
import { GiftIcon, HeartIcon } from 'lucide-react';
type AudienceCard = {
  title: string;
  text: string;
  icon: React.ElementType;
  /** Color del ícono y de su fondo */
  chip: string;
};
const audienceCopy = {
  eyebrow: 'Pensado para vos',
  title: 'Ya sea tu Baby Shower o el de alguien especial…',
  subtitle: 'Los juegos ya están preparados para que puedas lucirte organizando y compartir un momento hermoso con amigos y familia.',
  closing: 'Una misma colección, muchas formas de celebrar.'
};
const audienceCards: AudienceCard[] = [{
  title: 'Si sos la futura mamá',
  text: "Tené resuelta la diversión de tu baby shower con juegos listos para imprimir. Para que tus invitados la pasen hermoso y vos también disfrutes.",
  icon: HeartIcon,
  chip: 'bg-[#FDE3EC] text-[#E74D7A]'
}, {
  title: 'Si lo organizás para alguien especial',
  text: "Lucite preparando un baby shower divertido y memorable, sin pasar horas pensando qué hacer. Los juegos ya los preparamos por vos.",
  icon: GiftIcon,
  chip: 'bg-[#DDF2F1] text-[#15ADA8]'
}];
export function AudienceFit() {
  return <section aria-labelledby="audience-title" className="bg-[#FBF6EE] py-11 md:py-16" data-id="element-1" data-mp="2jddqpyl7t2j7">
      <div className="mx-auto max-w-4xl px-5 sm:px-6" data-id="element-2" data-mp="25duv259lbjns">
        <header className="mx-auto max-w-2xl text-center" data-id="element-3" data-mp="25dcrsooig56d">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-4" data-mp="2acfx8a8ekdev">
            {audienceCopy.eyebrow}
          </p>
          <h2 id="audience-title" className="mx-auto mt-4 max-w-[22ch] font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-5" data-mp="20g2ukmuvqp7z">
            {audienceCopy.title}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[16px] leading-relaxed text-body md:mt-4 md:text-[17px]" data-id="element-6" data-mp="1cq8joau4faqd">
            {audienceCopy.subtitle}
          </p>
        </header>

        <div className="mt-7 grid gap-3.5 md:mt-10 md:grid-cols-2 md:gap-5" data-id="element-7" data-mp="3jdzfh1vpoyfl">
          {audienceCards.map(({
          title,
          text,
          icon: Icon,
          chip
        }) => <article key={title} className="flex gap-4 rounded-3xl border border-[#EFE4D6] bg-white p-5 shadow-[0_10px_28px_-22px_rgba(139,107,85,0.45)] md:p-7" data-id="element-8" data-mp="3al5m60jfjyiq">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${chip}`} aria-hidden="true" data-id="element-9" data-mp="35nvyapbovux0">
                <Icon className="h-5 w-5" strokeWidth={1.6} data-id="element-10" data-mp="64l619en9j67" />
              </span>
              <div data-id="element-11" data-mp="2380z1jdlk0c">
                <h3 className="font-display text-[17px] font-bold leading-snug text-[#4A3A35] md:text-[19px]" data-id="element-12" data-mp="3tbn8nndo5xvn">{title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-body md:text-[16px]" data-id="element-13" data-mp="3od29zse2fm9b">{text}</p>
              </div>
            </article>)}
        </div>

        
      </div>
    </section>;
}